<template>
  <div class="flex flew-row">
    <NumericInput
      :value="localWeightInStone"
      min="0"
      max="100"
      aria-label="stone"
      inputId="weightMajor"
      :input-style="inputStyle"
      :measurement-indicator="measurementIndicators.stone"
      @input="localWeightInStone = $event"
      @blur="handleBlur"
    />
    <NumericInput
      :value="localWeightInPounds"
      min="0"
      max="13"
      aria-label="pounds"
      inputId="weightMinor"
      :input-style="inputStyle"
      :measurement-indicator="measurementIndicators.pounds"
      @input="localWeightInPounds = $event"
      @blur="handleBlur"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { validateInput } from "../../SimpleBmiQuestion/validation";
import NumericInput from "./NumericInput.vue";
import { ImperialWeightMeasurementIndicators } from "../../../types";

export default Vue.extend({
  components: { NumericInput },
  props: {
    weightInStone: { type: Number, required: true },
    weightInPounds: { type: Number, required: true },
    inputStyle: { type: String, required: true },
    measurementIndicators: { type: Object as PropType<ImperialWeightMeasurementIndicators>, required: true },
  },
  computed: {
    localWeightInStone: {
      get() {
        return this.weightInStone;
      },
      set(value) {
        const emitValue = validateInput(value, 100);
        this.$emit("update:weightInStone", emitValue);
      },
    },
    localWeightInPounds: {
      get() {
        return this.weightInPounds;
      },
      set(value) {
        const emitValue = validateInput(value, 13);
        this.$emit("update:weightInPounds", emitValue);
      },
    },
  },
  methods: {
    handleBlur() {
      if (this.localWeightInStone !== null && this.localWeightInPounds !== null) {
        this.$emit("blur");
      }
    },
  },
});
</script>
